<template>
  <v-container fluid class="pa-0 transparencia">
    <v-container class="mb-15">
      <h2 class=" pl-2">{{ $t("transparencia") }}</h2>

      <v-layout row wrap class="mt-15">
        <v-flex
          xs12
          sm6
          md6
          lg6
          xl6
          class="align-center justify-center d-flex px-4"
          v-for="(proceso, index) in procesos"
          :key="index"
        >
          <ProcessCell data-aos="fade-up" :data-aos-delay="50 * index" :process="proceso" />
        </v-flex>
      </v-layout>
    </v-container>
    <ScrollToTop />
  </v-container>
</template>

<script>
import { ProcessCell } from "../components/Lists";
import { ScrollToTop } from "../components/Form";
export default {
  name: "transparencia-wrapper",
  //{v-container, v-row, v-col, v-flex, v-layout}
  components: { ProcessCell, ScrollToTop },
  data: () => ({
    procesos: [
      {
        name: "Estatutos, Reglamentos y Manuales",
        image: "law_books.jpeg",
        subtitle: "Normatividad del Instituto y nuestro Manual de Organización.",
        route: "erm"
      },
      {
        name: "Informes",
        image: "informes.jpeg",
        subtitle: "Los informes de actividades de los directores del Instituto.",
        route: "Informes"
      },
      {
        name: "Consejos, Comités y Actas",
        image: "sign.jpeg",
        subtitle:
          "Integrantes de las distintas comisiones y comités que integran nuestro instituto. ",
        route: "cca"
      },
      {
        name: "Brigada de Seguridad ",
        image: "cpr.jpeg",
        subtitle: "Integrantes de la brigada de seguridad del Instituto.",
        route: "brigada"
      }
    ]
  })
};
</script>
<style lang="scss" scooped>
.transparencia {
  margin-top: 150px;
}
@media (max-width: 960px) {
  .transparencia {
    margin-top: 75px;
  }
}
</style>
<style lang="scss" scoped>
@media (min-width: 960px) {
  .transparencia {
    .container {
      max-width: 1000px;
    }
  }
}
</style>
